<template>
	<div class="cj">
		<!-- 背景图 -->
		<div class="bg">
			<img src="./images/bg.jpg" mode="widthFix" class="ImageBG" />
		</div>
		<van-notice-bar
		  left-icon="volume-o"
		 :text="winnerText"
		 class="winnerList" v-if="winnerList.length>0"
		/>
		<div class="cell">
			<div v-for="(item,index) in AwardList" :key="index">
				<div v-if="index==4 && status==2" class="gray">
					<div class="CellItem" :class="index==4||index===sel?'YellowBackground':'WhiteBackground'">
						<div class="CellItemContent" :class="index==4||index===sel?'Yellow':'white'">
							<img src="./images/begin.png" class="ItemImage" />
							<div class="">
								<p class="text">{{item.name}}</p>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="CellItem" :class="index==4||index===sel?'YellowBackground':'WhiteBackground'" @click.stop="begin(index)">
						<div class="CellItemContent" :class="index==4||index===sel?'Yellow':'white'">
							<img src="./images/j2.png" class="ItemImage" v-if="index==0" />
							<img src="./images/j2.png" class="ItemImage" v-if="index==1||index==7" />
							<img src="./images/j2.png" class="ItemImage" v-if="index==2||index==6" />
							<img src="./images/j2.png" class="ItemImage" v-if="index==3||index==5" />
							<img src="./images/begin.png" class="ItemImage" v-if="index==4 && status==0" />
							<img src="./images/begin2.png" class="ItemImage" v-if="index==4 && status==1" />
							<img src="./images/begin3.png" class="ItemImage" v-if="index==4 && status==3" />
							<img src="./images/thanks.png" class="ItemImage" v-if="index==8" />
							<div class="">
								<p class="text">{{item.name}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<van-popup v-model="show" round :close-on-click-overlay="false" class="popupClass" v-if="start">
			<div class="infoText">
				<p>{{info}}
				</p>
				<van-button type="danger" size="large" v-if="showToList" @click="toList">查看</van-button>
				<van-button type="danger" size="large" v-else @click="closePopup">确定</van-button>
			</div>
		</van-popup>
		<van-popup v-model="show" round v-else :close-on-click-overlay="false" class="popupClass">
			<div class="countdown">
				<h3>抽奖倒计时</h3>
				<p>{{countdown}}</p>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		reqActivity,
		reqTurndraw,
		reqTurnrecord,
		reqWard,
		reqCheck
	} from '../../api'
	export default {
		data() {
			return {
				AwardList: [],
				winnerList: [],
				sel: '',
				FastNums: 0,
				SlowNums: 0,
				time: 1000,
				LoopStatus: true,
				show: false, //是否显示弹层
				isCan: false, //是否可以抽奖
				start: true, //活动是否开始
				status: '', //中奖状态
				drawName: '',//奖品名称
				playName: '立即抽奖',//抽奖按钮名称
				isRefresh: false,//是否刷新页面
				info: '您已参与抽奖，请不要重复参与！',//中奖状态弹出信息
				showToList: false, //是否显示中奖查看按钮
				countdown: '', //倒计时
				winnerText:'',//中奖者信息
				
			}
		},
		created() {
			var usrChildFlg = this.$cookies.get('userInfo').openId;
			if (!usrChildFlg) {
				var wxUserInfo = localStorage.getItem('wxUserInfo');
				if (wxUserInfo) {
					usrChildFlg = JSON.parse(wxUserInfo).openid
					if (!usrChildFlg) {
						Toast.fail({
							message: '未获取到登录信息，请重新登录',
							className: 'apiLoading',
							onOpened: () => {
								this.$router.push({
									path: '/login',
									name: 'login'
								})
							}
						});
						return false
					}
				} else {
					Toast.fail({
						message: '未获取到登录信息，请重新登录',
						className: 'apiLoading',
						onOpened: () => {
							this.$router.push({
								path: '/login',
								name: 'login'
							})
						}
					});
					return false
				}
				return false
			}
			this.init();
			this.getList();
			this.winner();
			setTimeout(()=> {
				this.check();
			}, 100);
		},
		methods: {
			//信息
			init() {
				reqActivity().then(res => {
					if (res.startTime) {
						if (res.currentTimeLong > res.endTimeLong) {
							this.isCan = false
							this.show = true;
							this.info = "活动已结束！";
							return false
						} else if (res.currentTimeLong < res.startTimeLong) {
							this.isCan = false
							this.show = true;
							this.start = false;
							var temp = res.startTimeLong - res.currentTimeLong;
							this.timeEvent(temp)
						}
					}
				})
			},
			//倒计时计算
			timeEvent(temp) {
				var tempd = Math.floor(temp / (1000 * 60 * 60 * 24)); //计算天数
				var temph = Math.floor(temp / (1000 * 60 * 60) % 24); //计算小时数
				var tempm = Math.floor(temp / (1000 * 60) % 60); //计算分钟数
				if (tempm < 10) {
					tempm = "0" + tempm;
				}
				var temps = Math.floor(temp / 1000 % 60); //计算秒数
				if (temps < 10) {
					temps = "0" + temps;
				}
				this.countdown = tempd + "天" + temph + ":" + tempm + ":" + temps;
				setTimeout(() => {
					var t = temp - 1000;
					if (t > 0) {
						this.timeEvent(t);
					} else {
						this.closePopup();
					}
				}, 1000)
			},
			//奖品列表
			getList() {
				reqTurndraw().then(res => {
					if (res.length > 0) {
						this.AwardList = [];
						res.forEach(item => {
							this.AwardList.push({
								name: item.drawName
							});
						})
						this.AwardList.splice(4, 0, {
							name: this.playName
						});
					}
				})
			},
			//中奖记录
			winner() {
				reqTurnrecord({}).then(res => {
					if (res.length > 0) {
						this.winnerList = res;
						this.winnerText = "";
						for(var i=0;i<res.length;i++){							
							this.winnerText +=  "恭喜用户"+res[i].phone+"获得"+res[i].drawName+"! ";
						}
					}
				})
			},
			//检查状态
			check() {
				var params = {
					phone: this.$cookies.get('userInfo').account
				};
				reqCheck(params).then(res => {
					if (res == '1') {
						if(!this.isRefresh){
							this.show = true;							
						}
						this.info = "您今天已参与抽奖，请明天再参与！";
						this.playName = "明天再来"
						this.isCan = false
						this.isRefresh = false
					} else if (res == '2') {
						if(!this.isRefresh){
							this.show = true;							
						}
						this.isCan = false						
						this.info = "您已中奖，敬请关注下次活动！";
						this.isRefresh = false
					// } else if (res == '3') {
					// 	this.isCan = false
					// 	this.show = true;
					// 	this.info = "活动已结束！";
					// 	this.playName = "活动结束"
					} else if (res == '0') {
						this.isCan = true
						this.playName = "立即抽奖"
					}
					this.status = res;
					this.AwardList[4].name = this.playName
				})
			},
			//关闭弹出框
			closePopup() {
				this.show = false				
				if (this.isRefresh) {
					
					this.init();
					this.getList();
					this.winner();
					this.check();
					//window.location.reload();
				}
			},
			//开始抽奖
			begin(index) {
				if (this.isCan) {
					if (index == 4) {
						var params = {
							phone: this.$cookies.get('userInfo').account,
							userId: this.$cookies.get('userInfo').userId
						};
						this.isCan = false
						reqWard(params).then(res => {
							if (res.drawId) {
								this.drawName = res.drawName;
								this.FastNums = 0
								this.SlowNums = 0
								this.time = 1000
								this.LoopStatus = true
								this.loop(res.drawId)
							}
						})
					}
				}else{
					if (this.status == '1') {
						this.info = "您今天已参与抽奖，请明天再参与！";
					} else if (this.status == '3') {
						this.info = "活动已结束！";
					}
					this.show = true;
				}
			},
			//抽奖计算
			loop(num) {
				if (!this.sel || this.sel < 9) {
					if (this.sel == 3) {
						this.sel = 0
					} else if (this.sel === '') {
						this.sel = 0
					} else if (this.sel == 2) {
						this.sel = 5
					} else if (this.sel == 5) {
						this.sel = 8
					} else if (this.sel == 8) {
						this.sel = 7
					} else if (this.sel == 7) {
						this.sel = 6
					} else if (this.sel == 6) {
						this.sel = 3
					} else {
						this.sel++
					}
					this.FastNums++
					if (this.FastNums == 4) {
						this.FastNums = 0
						this.time = 50
						this.SlowNums++
					}
					if (this.SlowNums == 8) {
						this.SlowNums = 0
						this.time = 500
						this.FastNums = 5
					}
					if (this.FastNums > 5) {
						if (parseInt(this.sel) == parseInt(num) - 1) {
							this.LoopStatus = false;
							this.show = true;
							if (num != 9) {
								this.info = "恭喜你,获得奖品" + this.drawName + "!";
								this.showToList = true
							} else {
								this.info = "别灰心，请明天继续参与！";
							}
							this.isRefresh = true
						}
					}
					if (this.LoopStatus) {
						setTimeout(() => {
							this.loop(num)
						}, this.time);
					}
				}
			},
			toList() {
				this.$router.replace({
					path: '/coupon',
					name: 'coupon'
				})
			},
		}

	}
</script>

<style scoped>
	.cj {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.bg {
		width: 100%;
	}

	.cell {
		position: absolute;
		top: 645px;
		left: 82px;
		height: 200px;
		display: flex;
		flex-wrap: wrap;
	}

	.CellItem {
		width: 188px;
		height: 188px;
		border-radius: 30px;
		margin: 5px 4px;
	}

	.CellItemContent {
		width: 188px;
		height: 168px;
		border-radius: 30px;
		text-align: center;
	}

	.white {
		background-color: #fdf2ee;
	}

	.WhiteBackground {
		background-color: #f8d0c3;
	}

	.Yellow {
		background-color: #ffcc00;
		color: #FFFFFF;
	}

	.YellowBackground {
		background-color: #dd8e03;
	}
	.ImageBG {
		width: 100%;
	}

	.ItemImage {
		width: 90px;
		height: 90px;
		margin-top: 10px;
	}
	
	.gray .Yellow{
		background-color: #ddd;
	}
	.gray .YellowBackground{
		background-color: #CCCCCC;
	}
	.gray .ItemImage{
		-webkit-filter: grayscale(100%);
		-moz-filter: grayscale(100%);
		-ms-filter: grayscale(100%);
		-o-filter: grayscale(100%);
		filter: grayscale(100%);
		filter: gray;
		opacity:0.7;
	}
	.text {
		font-size: 28px;
	}

	.winnerList {
		position: absolute;
		top: 550px;
		left: 80px;
		right: 50px;
		height: 50px;
		font-size: 28px;
		background-color: transparent;
		color: #0074D9;
	}

	.winnerList >>> .van-icon {
		font-size: 40px;
		margin-right: 10px;
	}
	.winnerList >>> .van-notice-bar__wrap{
		height: 50px;
	}
	.winnerList >>> .van-notice-bar__content{
		line-height: 50px;
		height: 50px;
	}

	.notice-swipe {
		height: 40px;
		line-height: 40px;
	}

	.popupClass {
		background-color: transparent;
	}

	.infoText {
		background-color: #fff;
		font-size: 28px;
		line-height: 40px;
		padding: 25px;
	}

	.infoText p {
		margin-bottom: 20px;
	}

	.countdown {
		text-align: center;
		padding: 50px;
		color: #fff;
		background-color: rgba(255, 0, 0, 0.3);
		font-size: 55px;
		line-height: 80px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/choujiang/choujiang.vue